import script from "./PropertyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetails.vue?vue&type=style&index=0&id=d6f5b316&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6f5b316"]])

export default __exports__